var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline-block"},[_c('v-chip',_vm._g({staticClass:"white--text day-chip date-chip my-2 mr-1 px-2 py-0"},_vm.$listeners),[_c('span',[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }